import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import AddButton, { DraftButton } from "../../buttons/button";
import CloseIcon from "../../../assets/icons/close-icon";
import ItemsInputFieldStandalone from "../../forms/standalone-input-field";
import errorToast from "../../helper-components/error-toast";

// Asks the user to type the price list name before it is voided
const VoidPriceListModal = ({
  isModalOpen = false,
  setIsModalOpen,
  priceListName = "",
  onConfirm = () => {},
}) => {
  const [typedName, setTypedName] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (isModalOpen) {
      setTypedName("");
      setError("");
    }
  }, [isModalOpen]);

  const handleClose = () => setIsModalOpen(false);

  const handleConfirm = () => {
    if (!typedName.trim()) {
      setError("Please enter the price list name");
      return;
    }
    if (typedName.trim() !== priceListName.trim()) {
      setError("Price list name does not match");
      errorToast("Price list name does not match");
      return;
    }
    setIsModalOpen(false);
    onConfirm();
  };

  return (
    <Transition show={isModalOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        onClose={handleClose}
      >
        <div className="flex items-center justify-center min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-100"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4"
            enterTo="opacity-100 translate-y-0"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-4"
          >
            <div className="mx-auto w-full max-w-lg my-8 text-left align-middle transition-all transform bg-white shadow-xl rounded-xl">
              <div className="flex justify-between px-6 py-5">
                <h2 className="fw_500">Void Price List</h2>
                <button
                  type="button"
                  className="close-button bg-transparent border-none p-0 hover:bg-787878"
                  onClick={handleClose}
                >
                  <CloseIcon />
                </button>
              </div>
              <div className="px-6 flex flex-col gap-3">
                <p className="text-sm text-[var(--secondary)]">
                  Are you sure you want to delete the price list{" "}
                  <span className="fw_600">{priceListName}</span>?
                </p>
                <p className="text-sm text-[var(--placeholder-color)]">
                  Type the price list name to confirm.
                </p>
                <ItemsInputFieldStandalone
                  isLabelReq={false}
                  placeholder="Enter price list name"
                  value={typedName}
                  onChange={(e) => {
                    setTypedName(e.target.value);
                    if (error) setError("");
                  }}
                />
                {error && (
                  <span className="text-xs text-[var(--error-color)]">
                    {error}
                  </span>
                )}
              </div>
              <div className="px-6 flex justify-between gap-4 py-5">
                <DraftButton onclkFn={handleClose} text="No" />
                <AddButton
                  onclkFn={handleConfirm}
                  type="button"
                  className="bg-primary text-white px-8 py-2 rounded flex justify-center fw_500 text-sm"
                  text="Yes"
                  prefixIcon={false}
                />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default VoidPriceListModal;
